export function inThreeDays() {
  const date = new Date();
  date.setDate(date.getDate() + 3);
  return date;
};

export function tomorrow() {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  return date;
};

export function inXHours(hours) {
  const date = new Date();
  date.setHours(date.getHours() + hours);
  return date;
};